import { render, staticRenderFns } from "./CaseDataPreview.vue?vue&type=template&id=7181fbf8&scoped=true&"
import script from "./CaseDataPreview.vue?vue&type=script&lang=js&"
export * from "./CaseDataPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7181fbf8",
  null
  
)

export default component.exports